import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import _ from 'lodash';
import { lifecycle } from 'recompose';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

const propTypes = exact({
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onDragStart: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
});

const equipmentTypes = () => {
  return [{ id: 1, name: 'Truck' }, { id: 2, name: 'Trailer' }, { id: 3, name: 'Equipment' }, { id: 4, name: 'Pickup' }];
};

const EquipmentTypeListInput = (props) => {
  const {
    value, onChange, onBlur, onFocus, disabled,
  } = props;

  const onSelectItem = (selectedItem) => {
    onChange(selectedItem.name);
  };

  return (
    <React.Fragment>
      <InputGroup>
        <DropdownList
          inputProps={{
            className: 'form-control',
          }}
          filter="contains"
          allowCreate="onFilter"
          value={value}
          data={equipmentTypes()}
          onChange={(item) => { onSelectItem(item); }}
          valueField="name"
          textField="name"
          onFocus={onFocus}
          disabled={disabled}
          onBlur={() => { onBlur(); }}
        />
        <InputGroup.Button>
          <Button
            name="cancel"
            disabled={!value}
            /* calling onBlur event to change touched flag to show error if need be */
            onClick={(e) => {
              onBlur(e);
              onChange(null);
            }}
          >
            <Glyphicon glyph="remove" />
          </Button>
        </InputGroup.Button>
      </InputGroup>
    </React.Fragment>
  );
};

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      value,
      onChange,
    } = this.props;
    const types = equipmentTypes();

    const result = _.find(types, (type) => {
      return type.name === value;
    });

    if (!result) {
      onChange(null);
    }
  },
});

EquipmentTypeListInput.propTypes = propTypes;


export default withInitPage(EquipmentTypeListInput);
